import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/map` is retired — it is `/calendar` now.
 *
 * The map composed a page of rooms per track, which made it a second radar: both
 * answered "where is my ICP", both were ordered by fit, both had an approve
 * button. The radar absorbed the deciding, and this slot became the thing the
 * radar was missing — a place where approving something visibly lands.
 *
 * Kept as a redirect rather than deleted. The old path is in her history, in the
 * generated maps' own links, and in `?goal=` URLs she may have bookmarked; a 404
 * would read as the feature having been removed rather than moved.
 *
 * `replace` so the back button skips it instead of bouncing her here again.
 */
export const Route = createFileRoute("/map")({
  beforeLoad: () => {
    throw redirect({ to: "/calendar", replace: true });
  },
});
